<template>
  <div class="news">
    <div class="top-img">
      <img style="width: 100%;" src="@/assets/images/k2hqdmpfendk2hqdmpfend.jpg"
           alt="YwgA84rAI">
    </div>
    <div class="news-row container">
      <div class="new-recently" data-aos="fade-right" data-aos-duration="1500"
           :class="{'zero-recently': noticeList.length === 0}">
        <img src="@/assets/images/th.gif" alt="th" height="100%">
        <b>最新通告：&nbsp;&nbsp;</b>
        <el-carousel direction="vertical" :interval="7000"
                     indicator-position="none"
                     style="width: 1020px; height: 60px;">
          <el-carousel-item v-for="item in noticeList" :key="item.id">
            <p class="new-recently-text" @click="showNoticeContent(item)">{{ item.title }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="news-select">
        <div data-aos="fade-up" data-aos-duration="1500">
          <el-date-picker
              v-model="timeSlot"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              @change="getArticleList"
          >
          </el-date-picker>
          <el-select
              clearable
              v-model="categorizeChecked"
              placeholder="请选择文章类型"
              @change="getArticleList">
            <el-option
                v-for="item in categorizeList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-box" data-aos="fade-down" data-aos-duration="1500">
          <el-input
              placeholder="请输入文章标题"
              v-model="searchKey"
              clearable>
          </el-input>
          <button @click="getArticleList"><i class="el-icon-search"></i></button>
        </div>
      </div>
      <ul class="news-list" v-loading="loading1" element-loading-text="拼命加载中...">
        <li v-for="(article, index) in articleList" :key="article.id" data-aos="fade-left" data-aos-duration="1500">
          <a @click="getArticleContent(article.id)">
            <div class="news-img" v-if="article.cover_picture">
              <el-image :src="article.cover_picture" lazy>
                <div slot="placeholder" class="image-slot">
                  <img src="@/assets/images/loading.gif" alt="loading" style="width: 100px;">
                </div>
              </el-image>
            </div>
            <div class="news-content">
              <p class="news-title">{{ index + 1 + pageSize * (page - 1) }}、{{ article.title }}</p>
              <p class="news-text">{{ article.description }}</p>
            </div>
            <div class="news-info" style="font-size: 15px">
              <div>
                <span>{{ article.categorize_title }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span>{{ article.created_time.replace('T', ' ').substring(0, 19) }}</span>
              </div>
              <br/><br/><br/>
              <div>
                <span>访问次数：{{ article.visits }}</span>
              </div>
            </div>
          </a>
        </li>
        <el-empty :image-size="200" v-if="articleList.length === 0"></el-empty>
      </ul>
      <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 40, 50]"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogArticleVisible">
      <div v-loading="loading2" element-loading-text="拼命加载中..." class="article-model">
        <el-empty :image-size="200" v-if="articleContent.content.length === 0"></el-empty>
        <div v-html='articleContent.content.replace(/<img src/g, "<img data-src")'
             v-lazy-container="{ selector: 'img' }"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "News",
  data() {
    return {
      // 请求数据
      articleList: [],
      categorizeList: [],
      articleContent: {id: '', visits: '', content: ''},
      noticeList: [],

      // 初始化分页数据
      page: 1,
      pageSize: 25,
      total: 0,

      // 筛选
      timeSlot: "",
      searchKey: '',
      categorizeChecked: '',

      // 文章显示（对话框）
      dialogArticleVisible: false,

      // 加载
      loading1: false,
      loading2: false,
    }
  },
  computed: {
    // 处理后的筛选参数
    articleParams() {
      let params = {
        title: this.searchKey,
        categorize: this.categorizeChecked,
        created_time_after: this.timeSlot ? new Date(this.timeSlot[0]).toLocaleString() : '',
        created_time_before: this.timeSlot ? new Date(this.timeSlot[1]).toLocaleString() : ''
      }

      // 删除空参数
      for (const key in params) {
        if (params[key] === '' || !params[key]) {
          delete params[key]
        }
      }

      return params
    }
  },
  watch: {
    articleParams: {
      deep: true,
      handler() {
        this.page = 1
      },
    }
  },

  methods: {
    // 分页
    handleCurrentChange(val) {
      this.page = val
      this.getArticleList({page: this.page})
    },

    // 请求文章数据
    async getArticleList(params) {
      this.loading1 = true
      this.$api.reqArticleList({...this.articleParams, ...params}).then(results => {
        if (results.status === 200) {
          this.articleList = results.results
          this.pageSize = results.page_size
          this.total = results.count
        } else {
          Promise.reject('error')
        }
      }).catch(() => {
        this.$message({showClose: true, message: "新闻列表请求失败！", type: "error"})
      }).finally(() => {
        this.loading1 = false
      })
    },

    // 请求文章类型
    async getArticleCategorizeList() {
      let results = await this.$api.reqArticleCategorizeList()
      if (results.status === 200) {
        this.categorizeList = results.results
      } else {
        this.$message({showClose: true, message: '类型列表请求失败！', type: 'error'})
      }
    },

    // 请求文章内容
    async getArticleContent(pk) {
      this.dialogArticleVisible = true
      if (this.articleContent.id !== pk) {
        this.articleContent = {id: '', content: ''}
        this.loading2 = true

        this.$api.reqArticleContent(pk).then(results => {
          if (results.status === 200) {
            this.articleContent = results.results
            this.articleList.forEach(article => {
              if (article.id === pk) article.visits = results.results.visits
            })
          } else {
            Promise.reject('error')
          }
        }).catch(() => {
          this.$message({showClose: true, message: '文章内容请求失败！', type: 'error'})
        }).finally(() => {
          this.loading2 = false
        })
      }
    },

    // 请求最新通告
    async getNoticeList() {
      const results = await this.$api.reqNoticeList()
      if (results.status === 200) {
        this.noticeList = results.results
      } else {
        this.$message({showClose: true, message: '最新通告请求失败！', type: 'error'})
      }
    },

    // 显示最新通告详细内容
    async showNoticeContent(notice) {
      this.articleContent = notice
      this.dialogArticleVisible = true
    }
  },

  mounted() {
    const {pk, searchKey} = this.$route.params
    if (searchKey) {
      this.searchKey = searchKey
      this.getArticleList({title: searchKey})
    } else {
      this.getArticleList()
    }

    this.getNoticeList()

    this.getArticleCategorizeList()

    if (pk) {
      this.getArticleContent(pk)
    }
  }
}
</script>

<style scoped lang="less">
.news {

  .line-feed() {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .news-row {
    padding-bottom: 80px;

    .new-recently {
      display: flex;
      justify-content: left;
      align-items: center;
      margin: 20px 0;
      height: 60px;
      font-size: 17px;
      line-height: 60px;

      .line-feed();

      img {
        margin-bottom: 7px;
        margin-right: 10px;
      }

      .new-recently-text {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .zero-recently {
      opacity: 0;
      height: 0;
      overflow: hidden;
    }

    .news-select {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
    }

    .news-list {

      li {
        padding: 20px 0;
        border-bottom: 1px solid #f0f0f0;

        &:first-child {
          border-top: 1px solid #f0f0f0;
        }

        &:hover {
          cursor: pointer;
        }

        a {
          display: flex;
          justify-content: space-between;

          &:hover {
            .news-content > .news-title {
              color: #1E55AE;
              text-decoration: underline;
            }
          }

          & > .news-info {
            text-align: right;
          }

          .news-img {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 170px;
            height: 105px;
            border-radius: 7px;
            overflow: hidden;

            img {
              width: 170px;
            }
          }

          .news-content {
            margin-right: 120px;
            width: 610px;

            .news-title {
              width: 100%;
              font-size: 17px;
              color: #333;
              line-height: 45px;
              .line-feed();
            }

            .news-info {
              color: #878787;
              font-size: 15px;
            }
          }

          .news-text {
            width: 100%;
            font-size: 15px !important;
            color: #999999;
            line-height: 30px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
      }
    }

    .el-pagination {
      display: flex;
      justify-content: center;
      margin-top: 50px;
    }

    .el-date-editor--datetimerange.el-input__inner {
      width: 430px;
    }

    .el-range-editor .el-input__inner {
      justify-content: right;
    }

    .el-select {
      margin-left: 20px;
    }
  }
}

/deep/ .el-dialog {
  margin-top: 5vh !important;
  padding: 60px 0;
  width: 1150px;

  .el-dialog__body {
    margin: auto;
    width: 900px;
  }
}
</style>
